import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import { AuthService } from './services/auth.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[showAuthed]',
})
export class ShowAuthedDirective implements OnInit {

  constructor(
    private templateRef: TemplateRef<any>,
    private auth: AuthService,
    private viewContainer: ViewContainerRef,
  ) {}

  condition: boolean;
  hasView = false;

  @Input() set showAuthed(condition: boolean) {
    this.condition = condition;
    // console.log('ShowAuthed - Condition set to : ', this.condition);
  }

  ngOnInit() {
    this.auth.isLoggedIn().subscribe(
      (isLoggedIn) => {
        // console.log('show auth isLoggedIn( isLoggedIn, condition, hasView): ', isLoggedIn, this.condition, this.hasView);

      //  if (!this.hasView && (isLoggedIn && this.condition || !isLoggedIn && !this.condition)) {
        if (!this.hasView && isLoggedIn === this.condition ) {
          // console.log('show template');
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        }

        if (this.hasView && isLoggedIn !== this.condition ) {      
          // console.log('remove template');
          this.viewContainer.clear();
          this.hasView = false;
        }
      },
    );
  }
}

// tslint:disable-next-line:max-classes-per-file
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[hasPriv]',
})
export class HasPrivDirective implements OnInit {

  constructor(
    private templateRef: TemplateRef<any>,
    private auth: AuthService,
    private viewContainer: ViewContainerRef,
  ) {}

  condition: string;
  hasView = false;

  @Input() set hasPriv(condition: string) {
    this.condition = condition;
  }

  ngOnInit() {
    this.auth.isLoggedIn().subscribe(
      (isLoggedIn) => {
        // console.log('hasPriv ( isLoggedIn, condition, hasView): ', isLoggedIn, this.condition, this.hasView);

        if (!this.hasView && this.auth.hasPriv(this.condition)) {
          // console.log('show template');
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        } else {
          // console.log('remove template');
          this.viewContainer.clear();
          this.hasView = false;
        }
      },
    );
  }
}
